import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { FaEdit } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import TagModalContent from "./ModalContent/TagModalContent";
import { useAddTAges, useGETAllTage, useUpdateTag } from "./useProduct";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";

const tagDataColumns = (handleUpdate: (row: any, Status: string) => void) => [
  {
    name: "Tag Name",
    selector: (row: { tagname: number | string }) => row.tagname,
    sortable: true,
  },
  {
    name: "Created At",
    selector: (row: { created: string }) => row.created,
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdate(row, "Update")}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const Tags = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editType, setEditType] = useState<number | null>(null);
  const [status, setStatus] = useState<string>("");
  const [tagName, setTagName] = useState<string>("");
  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");
  const [filter, setFilter] = useState({ page: 1, limit: 10 });
  const [inputSearch, SetInputSearch] = useState<any>("");
  const [disabled, setDisabled] = useState<boolean>(false);
  //API
  const { mutate: addTage } = useAddTAges();
  const { mutate: updateTage } = useUpdateTag();

  const { data, isSuccess, isLoading } = useGETAllTage({
    enable: true,
    params: {
      id: null,
      ...(inputSearch == "" ? {} : { search: inputSearch }),
      page: filter.page,
      limit: filter.limit,
    },
  });

  const tagData =
    !isLoading &&
    isSuccess &&
    data?.data?.data?.map((item: any) => ({
      id: item?.Id || 0,
      tagname: item?.TagName || "-",
      created:
        item?.CreatedAt.split(".")[0] +
        "." +
        item.CreatedAt.split(".")[1]?.slice(0, 2),
    }));

  const toggleModal = (status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(!isModalOpen);
    setTagName("");
    setStatus("");
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setchechStatusSubmitAndUpdate("");
    setStatus("");
  };

  const handleUpdate = (row: any, status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setTagName(row.tagname);
    setEditType(row.id);
    setStatus("Edit");
    setIsModalOpen(true);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Add Tag
    if (tagName !== "" && editType === null) {
      const body = {
        tag_name: tagName,
      };
      addTage({ ReqBody: body });
    }

    /// Update Tage
    if (tagName !== "" && editType !== null) {
      const body = {
        tag_name: tagName,
      };
      updateTage({ ReqBody: body, id: editType });
    }
    setIsModalOpen(false);
  };

  // Pagination..
  const handlePage = (pageNo: number) => {
    setFilter((prev) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilter((prev) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };

  const handleSearach = (e: any) => {
    // console.log('eeee--->',e);
    SetInputSearch(e);
  };

  const handleDownload = async (fileType: string) => {
    let id = null;
    const appToken = localStorage.getItem("Apptoken") || "";
    const params: Record<string, any> = {
      ...(id === null ? {} : { id: id }),
      ...(inputSearch === "" ? {} : { search: inputSearch }),
    };
    const queryString = new URLSearchParams(params).toString();
    const apiEndpoint = `${BASE_URL}admin/api/getTagsExcel?${queryString}`;
    const fileName = "TagExcel.xlsx";

    try {
      setDisabled(true);
      const response = await downloadExcelGet({
        apiEndpoint,
        appToken,
        fileName,
      });
      if (response.success) {
        setDisabled(false);
      }
    } catch (error: any) {
      console.log("Error While downLoading Excel");
    } finally {
      setDisabled(false);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Tags"
        buttons={[
          {
            label: "+ Add Tags",
            onClick: () => toggleModal("Submit"),
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => handleDownload("Excel"),
            color:disabled?"#888": "#43B9B2",
            disable:disabled
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Tag list"
        dynamicHeightOnRowsPerPage={true}
        search={true}
        handleSearch={handleSearach}
        data={tagData}
        showSpinner={isLoading}
        columns={tagDataColumns(handleUpdate)}
        onChangePage={(pageNo: number) => {
          handlePage(pageNo);
        }}
        onChangeRowsPerPage={(newPage: any, page: any) => {
          handleonChangeRowsPerPage(newPage, page);
        }}
        paginationTotalRows={data?.data?.pagination?.total_records}
      />

      <RouteModal
        isOpen={isModalOpen}
        title={status === "Edit" ? "Edit Tag" : "Add Tag"}
        size="md"
        content={
          <TagModalContent
            tagName={tagName}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            setTagName={setTagName}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
          />
        }
      />
    </div>
  );
};

export default Tags;
